/**
 * PostHog project configuration.
 *
 * `POSTHOG_PROJECT_KEY` is a write-only ingest token. It cannot read data back,
 * so it ships in browser bundles by design and lives in source next to the
 * Amplitude project keys rather than in ESC. The personal API keys, which can
 * read, are the ones that stay secret.
 */
export const POSTHOG_PROJECT_KEY = 'phc_x3nBxeAXGbUDEB9ryiJKKmJCwxPft76cQGa9iQ9UoZgY'

export const POSTHOG_HOST = 'https://us.i.posthog.com'

/** Our reverse proxy to `POSTHOG_HOST`, so ad blockers don't drop browser events. */
export const POSTHOG_PROXY_HOST = 'https://g.highlightai.com'

/** Where links in the SDK (toolbar, replay) open, since the proxy can't serve the app. */
export const POSTHOG_UI_HOST = 'https://us.posthog.com'

/** Serves the JS SDK assets. Not the ingest host. */
export const POSTHOG_ASSET_HOST = 'https://us-assets.i.posthog.com'

export const POSTHOG_PROJECT_ID = 596592
